import React from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, makeStyles } from '@material-ui/core';
import { Typography } from '@klp/design';
import { NumberFormatted } from '@klp/formgenerator/components/NumberFormatted';
import { NumericField } from '@klp/prosjekt/components/Vurderingsskjema/components/Form/NumericField';

const useStyles = makeStyles((theme) => ({
    container: {
        marginTop: theme.spacing(2),
        alignItems: 'center',
    },
    label: {
        fontWeight: 'bold',
    },
    valueCell: {
        textAlign: 'right',
    },
}));

type ProsjektAvfallKlimagassFieldProps = {
    isEditMode: boolean;
    value: number | null;
    error?: string;
    onChange: (value: number | null) => void;
    layout?: 'row' | 'stacked';
};

export function ProsjektAvfallKlimagassField({
    isEditMode,
    value,
    error,
    onChange,
    layout = 'row',
}: ProsjektAvfallKlimagassFieldProps) {
    const { t } = useTranslation();
    const classes = useStyles();

    const isStacked = layout === 'stacked';

    const label =
        t('sustainability.prosjektAvfall.klimagassberegning') +
        ' (kg CO2ekv/m2)';

    return (
        <Grid container={true} spacing={1} className={classes.container}>
            <Grid item={true} xs={isStacked ? 12 : 7} sm={isStacked ? 12 : 9}>
                <Typography className={classes.label}>{label}</Typography>
            </Grid>
            <Grid
                item={true}
                xs={isStacked ? 12 : 5}
                sm={isStacked ? 12 : 3}
                className={isStacked ? undefined : classes.valueCell}
            >
                {isEditMode ? (
                    <NumericField
                        id="klimagassberegning"
                        variant="outlined"
                        size="small"
                        isReadOnly={false}
                        isRequired={false}
                        value={value ?? undefined}
                        onValueChange={(values) =>
                            onChange(values.floatValue ?? null)
                        }
                        error={!!error}
                        helperText={error}
                        inputProps={{ min: 0, step: 0.01 }}
                    />
                ) : (
                    <Typography>
                        {value !== null ? (
                            <NumberFormatted value={value} decimalScale={2} />
                        ) : (
                            '–'
                        )}
                    </Typography>
                )}
            </Grid>
        </Grid>
    );
}
